module.exports = __webpack_public_path__ + "img/Carrefour_logo.0c32d96f.png";